import React from "react";
import "./spinner.css";
import logoIconSvg from "../../../assets/images/LogoIcon.svg";

function Spinner() {
  return (
    <div className="spinner-container">
      <div className="spinner-wrapper">
        <div className="spinner-ring" />
        <div className="spinner-brand">
          <img src={logoIconSvg} alt="AdsOne" style={{ width: 28, height: 28, objectFit: "contain" }} />
        </div>
      </div>
      <span className="spinner-label">Loading...</span>
    </div>
  );
}

export default Spinner;
